import { PropsWithChildren } from 'react';
import { ButtonProps as MuiButtonProps } from '@mui/material';

import { COLORS } from '~/styles/colors';

import { StyledButton } from './styled';

export const BUTTON_TYPE = {
  contained: 'contained',
  outlined: 'outlined',
  primaryOutlined: 'primary-outlined',
  danger: 'danger',
  text: 'text',
} as const;

type ButtonProps = Omit<MuiButtonProps, 'size' | 'type'> &
  PropsWithChildren<{
    type?: (typeof BUTTON_TYPE)[keyof typeof BUTTON_TYPE];
    color?: string;
    backgroundColor?: string;
    hoverBackgroundColor?: string;
    borderColor?: string;
    size?: 'middle' | 'xs' | 'small';
    htmlType?: string;
  }>;

export const Button = ({
  type = BUTTON_TYPE.contained,
  htmlType = 'button',
  children,
  color,
  backgroundColor = COLORS.primary,
  hoverBackgroundColor = COLORS.primary,
  borderColor = COLORS.primary,
  size = 'middle',
  ...props
}: ButtonProps) => {
  const propsMapper = {
    [BUTTON_TYPE.contained]: {
      $backgroundColor: backgroundColor,
      $hoverBackgroundColor: hoverBackgroundColor,
      $textColor: color || COLORS.white,
      $size: size,
    },
    [BUTTON_TYPE.danger]: {
      $textColor: COLORS.white,
      $size: size,
      $hoverBackgroundColor: COLORS.white,
      $backgroundColor: COLORS.darkRed,
      variant: 'contained',
    },
    [BUTTON_TYPE.outlined]: {
      $textColor: color || COLORS.primary,
      $borderColor: borderColor,
    },
    [BUTTON_TYPE.primaryOutlined]: {
      $textColor: color || COLORS.primary,
      $borderColor: borderColor || COLORS.primary,
      $size: size,
      $hoverBackgroundColor: hoverBackgroundColor || COLORS.white,
      $backgroundColor: backgroundColor || COLORS.white,
      $isPrimaryOutlined: true,
      variant: 'outlined',
    },
  };

  const buttonProps: object = propsMapper[type] ?? {};

  return (
    <StyledButton variant={type} {...buttonProps} type={htmlType} {...props}>
      {children}
    </StyledButton>
  );
};
